import { generateBidIncrements } from '@bonhams1793/bonhams-typescript'

export const getNextBid = ({
  biddingPolicy,
  currentBidValue,
  isCurrentBidIncluded,
  isWinningBidder,
  maxBidValue,
  maxPossibleBidValue,
}: GetNextBidParams) => {
  if (isCurrentBidIncluded) {
    return currentBidValue
  }

  const baseBid =
    isWinningBidder && typeof maxBidValue === 'number'
      ? maxBidValue
      : currentBidValue

  if (typeof maxPossibleBidValue === 'number') {
    const [nextBidFromMax] = generateBidIncrements({
      policy: biddingPolicy,
      currentBid: baseBid,
      maxPossibleBid: maxPossibleBidValue,
    })

    return nextBidFromMax ?? baseBid
  }

  const [nextBidFromCurrent] = generateBidIncrements({
    policy: biddingPolicy,
    currentBid: baseBid,
    amountOfOptions: 1,
  })

  return nextBidFromCurrent
}

export interface GetNextBidParams {
  biddingPolicy: Record<string, number[]>
  maxBidValue?: number
  maxPossibleBidValue?: number
  currentBidValue: number
  isCurrentBidIncluded?: boolean
  isWinningBidder: boolean
}
